<template>
  <div class="login position-relative">
    <div class="background-figures login-left login-header-mobile login-aside d-flex flex-column align-items-center justify-content-center text-center" v-show="desktop">
      <ul class="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-sm-6 mx-auto">

          <!-- Confirm Email Message -->
          <div class="card-mt-2" v-if="showConfirm">
            <div class="card-body">
              <h3 class="strong mb-5 h3 confirm-title">{{ $t('confirmation_title') }}</h3>
              <img class="confirm-img" src="/static/img/icon_email_confirm.png" alt="confirmation-logo">
              <div class="confirm-description mt-5">
                <div v-html="$t('confirmation_description')"></div>
                <br>
                <button type="button" class="btn btn-default mt-1" @click="showConfirm = false;">
                  {{ $t('login_with_email') }}
                </button>
                <div @click="resendConfirmEmail()" class="link-to-confirm mt-4">
                  <b>{{ $t('confirmation_resend') }}</b>
                </div>
              </div>
            </div>
          </div>

          <div class="card mt-2" v-if="!showConfirm">
            <div class="card-body">
              <div class="text-center container-logo mb-4">
                <img src="/static/img/logo_dark_new.png" alt="logo" height="35" />
              </div>

              <!-- Login -->
              <div v-if="!showSignUp">
                <form class="login-form" @submit.prevent="login" id="login-form">
                  <div class="text-center mb-3">
                    <h3 class="strong h3 text-black">{{ $t('welcome_back') }}</h3>
                    <div class="fw-thin">{{ $t('are_you_registered') }}</div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errorCode === 'invalid_username' }">
                    <label for="username" class="placeholder">
                      <b>{{ $t('email') }}</b>
                    </label>
                    <input
                      :class="{ filled: email }"
                      v-model="email"
                      id="email"
                      name="email"
                      type="text"
                      class="form-control"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="none"
                      required
                    />
                  </div>
                  <div class="form-group" :class="{ 'has-error': errorCode === 'invalid_password' }">
                    <label for="password" class="placeholder">
                      <b>{{ $t('password') }}</b>
                    </label>
                    <a href="javascript:void(0)" @click="showRecovery()" tabindex="-1" class="link float-right">
                      <b>{{ $t('forget_password') }}</b>
                    </a>
                    <div class="position-relative">
                      <input
                        :class="{ filled: password }"
                        v-model="password"
                        id="password"
                        name="password"
                        type="password"
                        class="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errorCode === 'invalid_captcha' }">
                    <label for="captcha" class="placeholder">
                      <b>Captcha</b>
                    </label>
                    <div v-html="captcha"></div>
                    <input
                      :class="{ filled: captchaText }"
                      v-model="captchaText"
                      id="captcha"
                      name="captcha"
                      type="text"
                      class="form-control mt-2"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="none"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <button
                      type="submit"
                      class="btn btn-gradient col-md-12 mt-3 mt-sm-0 fw-bold"
                      :disabled="loading"
                    >{{ $t('sign_in') }}</button>
                  </div>
                </form>

                <div class="text-center fw-thin text-muted py-3">
                  {{ $t('or') }}
                </div>

                <div class="social-buttons">
                  <button class="btn btn-block btn-social" @click="loginGoogle()">
                    <img src="/static/img/g-logo.png" alt="g-logo" style="width:20px;">&nbsp;&nbsp;
                    {{ $t('login_with_google') }}
                  </button>
                  <!-- <a href="https://indiefy.net/v1/auth/twitter/connect" class="btn btn-block btn-social text-dark">
                    <i class="fab fa-twitter mr-1"></i>&nbsp;&nbsp;
                    {{ $t('login_with_twitter') }}
                  </a> -->
                  <!-- <button class="btn btn-block btn-social" @click="showRecovery(true)">
                    <img src="/static/img/f-logo-blue.png" alt="fb-logo" style="width:20px;">&nbsp;&nbsp;
                    {{ $t('login_with_facebook') }}
                  </button> -->
                </div>

                <div class="login-account mt-5 text-center">
                  <span class="msg">{{ $t('no_account_yet') }}</span>
                  <div class="mt-1 mb-2">
                    <router-link to="/signup"
                      id="show-signup"
                      class="btn btn-link ml-1"
                    ><b>{{ $t('sign_up') }}</b>
                    </router-link>
                  </div>
                </div>

                <div class="text-center mt-3">
                  <div>
                    <router-link class="nav-link" to="/terms#terms-conditions">
                      {{ $t('terms_and_conditions') }}
                    </router-link>
                  </div>
                  <div class="mt--2">
                    <router-link class="nav-link" to="/terms#privacy-policy">
                      {{ $t('privacy_policy') }}
                    </router-link>
                  </div>
                </div>
              </div>

              <!-- Signup -->
              <div v-if="showSignUp">
                <form class="login-form" @submit.prevent="signUp()" id="signup-form">
                  <div class="form-group">
                    <label for="email" class="placeholder">
                      <b>{{ $t('email') }}</b><span class="ml-1 text-danger">*</span>
                    </label>
                    <input
                      v-model="newUser.email"
                      id="email"
                      name="email"
                      type="email"
                      class="form-control"
                      required
                      :readonly="readOnlyEmail"
                      @blur="onChangeEmail()"
                    />
                  </div>
                  <div class="form-group">
                    <label for="first_name" class="placeholder">
                      <b>{{ $t('first_name') }}</b>
                    </label>
                    <input
                      v-model="newUser.first_name"
                      id="first_name"
                      name="first_name"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="last_name" class="placeholder">
                      <b>{{ $t('last_name') }}</b>
                    </label>
                    <input
                      v-model="newUser.last_name"
                      id="last_name"
                      name="last_name"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="form-group mb-1">
                    <label for="last_name" class="placeholder">
                      <b>{{ $t('phone_number') }}</b>
                    </label>
                    <VuePhoneNumberInput @update="onUpdatePhone" v-bind:default-country-code="defaultCountry" v-model="newPhoneNumber" />
                  </div>
                  <div class="form-group">
                    <label for="" class="placeholder">
                      <b>{{ $t('preferred_notification_medium') }}</b>
                    </label>
                    <select class="form-control" v-model="newUser.preferred_medium">
                      <option value="sms">SMS</option>
                      <option value="whatsapp">WhatsApp</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="passwordsignin" class="placeholder">
                      <b>{{ $t('password') }}</b><span class="ml-1 text-danger">*</span>
                    </label>
                    <div class="position-relative">
                      <input
                        v-model="newUser.password"
                        id="passwordsignin"
                        name="passwordsignin"
                        type="password"
                        class="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="confirmpassword" class="placeholder">
                      <b>{{ $t('confirm_password') }}</b><span class="ml-1 text-danger">*</span>
                    </label>
                    <div class="position-relative">
                      <input
                        v-model="newUser.password2"
                        id="confirmpassword"
                        name="confirmpassword"
                        type="password"
                        class="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-sub m-0">
                    <div class="custom-control custom-checkbox container-terms">
                      <input
                        v-model="newUser.agree"
                        type="checkbox"
                        class="custom-control-input"
                        name="agree"
                        id="agree"
                      />
                      <label class="custom-control-label" for="agree" v-html="$t('i_agree_terms')" style="line-height: 2.3em;">
                      </label>
                    </div>

                    <div class="custom-control custom-checkbox container-terms mt-4">
                      <input
                        v-model="newUser.newsletter"
                        type="checkbox"
                        class="custom-control-input"
                        name="newsletter"
                        id="newsletter"
                      />
                      <label class="custom-control-label label-break-spaces" for="newsletter" v-html="$t('i_agree_terms_newsletter')">
                      </label>
                    </div>
                  </div>
                  <div class="form-action">
                    <button
                        type="submit"
                        class="btn btn-gradient btn-block mt-3 fw-bold"
                        :disabled="loading"
                      >{{ $t('create_account') }}
                    </button>
                    <div class="yes-account col-md-12 text-center mt-2">
                      <span class="msg">{{ $t('yes_account') }}</span>
                      <div>
                        <router-link to="/login"
                          id="show-signup"
                          class="btn btn-link mt-1"
                        >
                          <b>
                          {{ $t('sign_in') }}
                          </b>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent="registerHubspot()" name="hubspot-sync" id="hubspot-sync" style="width: 5px; height: 5px; overflow:hidden;">
      <input type="email" id="hubspot-sync-email" name="email">
      <button type="submit" ref="hbSubmit"></button>
    </form>

    <div ref="modalTwoFactor" class="modal" tabindex="-1" role="dialog" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold">
              <i class="fa fa-exclamation-triangle mr-1 text-warning"></i>
              {{ $t('type_two_factor') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body">
            <input type="number" min="1000" max="9999" maxlength="4" v-model="twoFactorCode" class="form-control" placeholder="0000">
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" data-dismiss="modal">
              {{ $t('close') }}
            </button>
            <button type="button" class="btn btn-primary" @click="confirmTwoFactor()">
              {{ $t('confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import Auth from '../services/auth'
import Vue from 'vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import Public from '../services/public'

export default {
  name: 'Login',
  data () {
    return {
      upgraded: false,
      readOnlyEmail: false,
      defaultCountry: 'US',
      newPhoneNumber: '',
      googlePayload: {},
      isGoNative: navigator.userAgent.indexOf('gonative') >= 0,
      isMedian: navigator.userAgent.indexOf('median') >= 0,
      errorCode: '',
      captcha: '',
      captchaText: '',
      desktop: false,
      changeWord: false,
      currentWord: 0,
      words: ['fastest', 'easiest', 'most user friendly', 'best'],
      loading: false,
      showPassword: false,
      email: '',
      password: '',
      showSignUp: false,
      newUser: {
        preferred_medium: 'sms',
        source: 'web'
      },
      camiloId: '5b5f28a59e4a671925661353',
      showConfirm: false,
      twoFactorCode: '',
      userData: {}
    }
  },
  methods: {
    loginSuccess: function (userData) {
      _.extend(this.$user, userData)
      this.$eventBus.$emit('updateUser', this.$user)

      setTimeout(() => {
        if (this.$route.query.next) {
          this.$router.push(this.$route.query.next)
        } else if (this.$route.query.app) {
          if (this.$route.query.app === 'academy') {
            location.href = 'https://academy.indiefy.net/courses'
          }
        } else {
          if (this.$user.first_time) {
            window.smartlook && window.smartlook('track', 'Registration Success')
            window.fbq && window.fbq('track', 'CompleteRegistration')
            this.$router.push('/new-artist?welcome=1')
          } else {
            this.$router.push('/dashboard')
          }
        }
      }, 1)
    },
    confirmTwoFactor: function () {
      Auth.confirmTwoFactor(this.twoFactorCode).then(() => {
        this.loginSuccess(this.userData)
      }).catch(() => {
        this.$notify({ message: this.$t('code_is_not_valid') }, 'warning', 'fa-exclamation')
      })
    },
    onUpdatePhone: function (ev) {
      this.newUser.phone_code = '+' + ev.countryCallingCode
    },
    registerHubspot: function () {
      // console.log('User email', window.$('#hubspot-sync-email').val())
    },
    showRecovery: function (fromFacebook = false) {
      let html = document.createElement('div')
      let redirect = fromFacebook ? '<br>' + this.$t('dont_account_yet') : ''
      html.innerHTML = '<input class="form-control" placeholder="Email" type="text" id="recovery-email">' + redirect
      window.swal({
        title: this.$t('type_your_email'),
        text: fromFacebook ? this.$t('attention') + '\n' + this.$t('facebook_disabled') : '',
        closeOnEsc: false,
        closeOnClickOutside: false,
        content: html,
        buttons: {
          cancel: {
            text: this.$t('cancel'),
            visible: true,
            className: 'btn btn-default btn-border no-border'
          },
          confirm: {
            text: this.$t('confirm'),
            className: 'btn btn-primary'
          }
        }
      }).then(result => {
        if (result && window.$('#recovery-email').val()) {
          Auth.recover(window.$('#recovery-email').val()).then(response => {
            this.$notify({ message: this.$t('we_sent_new_password') }, 'success', 'fa-check')
          }, error => {
            console.log(error)
            this.$notify({ message: this.$t('recovering_password_error') }, 'warning', 'fa-exclamation')
          })
        }
      })
    },
    confirmEmail: function (userData, callback) {
      window.swal({
        closeOnClickOutside: false,
        closeOnEsc: false,
        title: this.$t('provide_email'),
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Email',
            type: 'email',
            id: 'email-modal-facebook',
            className: 'form-control',
            value: userData.email || ''
          }
        },
        buttons: {
          cancel: {
            visible: false
          },
          confirm: {
            text: this.$t('continue'),
            className: 'btn btn-success'
          }
        }
      }).then(() => {
        if (!window.$('#email-modal-facebook').val()) {
          return this.confirmEmail(userData, callback)
        } else if (!this.validateEmail(window.$('#email-modal-facebook').val())) {
          return this.confirmEmail(userData, callback)
        } else {
          callback(window.$('#email-modal-facebook').val())
        }
      })
    },
    loginFacebook: function () {
      const facebookScope = 'public_profile,email'

      window.FB.login(
        response => {
          if (response.status === 'connected') {
            window.FB.api('/me?fields=name,picture,first_name,last_name,email', userData => {
              if (this.$i18n && this.$i18n.locale) {
                userData.lang = this.$i18n.locale
              }

              if (userData.error_subcode && userData.error_subcode === 1357045) {
                alert('Ad blocker detected, please disable it.')
              }

              if (localStorage.getItem('referral')) {
                userData.referred_by_user = localStorage.getItem('referral')
                localStorage.removeItem('referral')
              }

              if (localStorage.getItem('user_source')) {
                userData.source = localStorage.getItem('user_source')
                userData.medium = localStorage.getItem('user_medium')
                userData.campaign = localStorage.getItem('user_campaign')
                localStorage.removeItem('user_source')
                localStorage.removeItem('user_medium')
                localStorage.removeItem('user_campaign')
              }

              if (this.$route.query.colombia === '1') {
                userData.embassy_referred = this.camiloId
              }

              this.confirmEmail(userData, (email) => {
                if (!email) {
                  return this.loginFacebook()
                }

                window.$('#hubspot-sync-email').val(email).change()
                this.$refs.hbSubmit.click()

                userData.email = email

                Auth.facebookLogin(userData).then(response => {
                  _.extend(this.$user, response.data)

                  this.$eventBus.$emit('updateUser', this.$user)

                  setTimeout(() => {
                    if (this.$route.query.next) {
                      this.$router.push(this.$route.query.next)
                    } else {
                      if (this.$user.first_time) {
                        window.smartlook && window.smartlook('track', 'Registration Success')
                        window.fbq && window.fbq('track', 'CompleteRegistration')
                        this.$router.push('/new-artist?welcome=1')
                      } else {
                        this.$router.push('/dashboard')
                      }
                    }
                  }, 1)
                }, error => {
                  this.errorCode = error.response.data.name

                  if (this.errorCode === 'duplicated_email') {
                    this.$notify({ message: this.$t('email_registered_try') }, 'warning', 'fa-exclamation')
                  }

                  if (this.errorCode === 'deactivated_account') {
                    this.$notify({ message: this.$t('deactivated_account') }, 'warning', 'fa-exclamation')
                  }
                })
              }, () => {
                this.loginFacebook()
              })
            })
          }
        },
        { scope: facebookScope }
      )
    },
    authGoogle: function (userData) {
      if (localStorage.getItem('utm_campaign')) {
        userData.utm_campaign = localStorage.getItem('utm_campaign')
      }

      if (this.$i18n && this.$i18n.locale) {
        userData.lang = this.$i18n.locale
      }

      userData.source = 'web'
      Auth.googleLogin(userData).then(response => {
        if (response.data && response.data.twofactor) {
          this.userData = response.data
          return window.$(this.$refs.modalTwoFactor).modal('show')
        }

        this.loginSuccess(response.data)
      }, error => {
        let message = error.response.data

        if (message.name === 'duplicated_email') {
          this.$notify({ message: this.$t('email_registered_try') }, 'warning', 'fa-exclamation')
        }

        if (message.name === 'deactivated_account') {
          this.$notify({ message: this.$t('deactivated_account') }, 'warning', 'fa-exclamation')
        }
      })
    },
    loginGoogleNative: function (response) {
      let idToken = response.idToken

      if (idToken) {
        let userData = window.KJUR.jws.JWS.parse(idToken)

        if (userData && userData.payloadObj && userData.payloadObj.sub) {
          userData = userData.payloadObj

          let payload = {
            provider_token: idToken,
            email: userData.email,
            name: userData.given_name || userData.name,
            profile_image: userData.picture,
            last_name: userData.family_name,
            id: userData.sub
          }

          if (this.$i18n && this.$i18n.locale) {
            payload.lang = this.$i18n.locale
          }

          this.authGoogle(payload)
        } else {
          alert('Error when trying to get data from Google')
        }
      } else {
        console.error('User cancelled login or did not fully authorize')
      }
    },
    loginGoogle: function () {
      if (!window.gapi) {
        return alert(this.$t('disable_ad_blocker'))
      }

      if (this.isMedian) {
        return window.median.socialLogin.google.login({ callback: this.loginGoogleNative })
      }

      if (this.isGoNative) {
        return window.gonative.socialLogin.google.login({ callback: this.loginGoogleNative })
      }

      const options = new window.gapi.auth2.SigninOptionsBuilder()
      options.setPrompt('select_account')
      window.gapi.auth2.getAuthInstance().signIn(options).then((authSuccess) => {
        window.gapi.client.people.people.get({
          'resourceName': 'people/me',
          'requestMask.includeField': 'person.names,person.email_addresses,person.metadata'
        }).then(response => {
          let locale = 'en'
          let accessToken = ''

          if (this.$i18n) {
            this.locale = this.$i18n.locale
          }

          if (window.gapi.auth2.getAuthInstance().currentUser && window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse()) {
            accessToken = window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().id_token
          }

          const userData = {
            id: _.find(response.result.metadata.sources, { type: 'PROFILE' }).id,
            email: response.result.emailAddresses[0].value,
            name: response.result.names[0].displayName,
            lang: locale,
            provider_token: accessToken
          }

          if (localStorage.getItem('referral')) {
            userData.referred_by_user = localStorage.getItem('referral')
            localStorage.removeItem('referral')
          }

          if (localStorage.getItem('user_source')) {
            userData.source = localStorage.getItem('user_source')
            userData.medium = localStorage.getItem('user_medium')
            userData.campaign = localStorage.getItem('user_campaign')
            localStorage.removeItem('user_source')
            localStorage.removeItem('user_medium')
            localStorage.removeItem('user_campaign')
          }

          if (this.$route.query.colombia === '1') {
            userData.embassy_referred = this.camiloId
          }

          if (userData.email) {
            window.$('#hubspot-sync-email').val(userData.email).change()
            this.$refs.hbSubmit.click()
          }

          this.authGoogle(userData)
        })
      })
    },
    signUp: function () {
      if (!this.newUser.email) {
        return this.$notify({ message: this.$t('type_email') }, 'warning', 'fa-exclamation')
      }

      if (!this.validateEmail()) {
        this.$notify({ message: this.$t('email_is_not_valid') }, 'warning', 'fa-exclamation')
        return
      }

      if (!this.newUser.password) {
        return this.$notify({ message: this.$t('type_password') }, 'warning', 'fa-exclamation')
      }

      if (this.newUser.password.length < 4) {
        return this.$notify({ message: this.$t('password_too_short') }, 'warning', 'fa-exclamation')
      }

      if (this.newUser.password && this.newUser.password !== this.newUser.password2) {
        return this.$notify({ message: this.$t('passwords_not_match') }, 'warning', 'fa-exclamation')
      }

      if (!this.newUser.agree) {
        return this.$notify({ message: this.$t('need_to_agree') }, 'warning', 'fa-exclamation')
      }

      if (this.newPhoneNumber) {
        if (this.newPhoneNumber.length && window.$('.input-tel.is-valid').length) {
          this.newUser.phone_number = this.newPhoneNumber
          this.newUser.phone_code = this.newUser.phone_code
        } else if (this.newPhoneNumber.length && !window.$('.input-tel.is-valid').length) {
          return this.$notify({ message: this.$t('please_type_valid_number') }, 'warning', 'fa-exclamation')
        }
      }

      this.newUser.username = this.newUser.email
      this.loading = true

      if (localStorage.getItem('referral')) {
        this.newUser.referred_by_user = localStorage.getItem('referral')
        localStorage.removeItem('referral')
      }

      if (this.$route.query.colombia === '1') {
        this.newUser.embassy_referred = this.camiloId
      }

      if (localStorage.getItem('user_source')) {
        this.newUser.source = localStorage.getItem('user_source')
        this.newUser.medium = localStorage.getItem('user_medium')
        this.newUser.campaign = localStorage.getItem('user_campaign')
        localStorage.removeItem('user_source')
        localStorage.removeItem('user_medium')
        localStorage.removeItem('user_campaign')
      }

      if (localStorage.getItem('utm_campaign')) {
        this.newUser.utm_campaign = localStorage.getItem('utm_campaign')
      }

      if (this.newUser.email) {
        window.$('#hubspot-sync-email').val(this.newUser.email).change()
        this.$refs.hbSubmit.click()
      }

      Auth.signUp(this.newUser).then(response => {
        this.loading = false
        this.showConfirm = true
        this.showSignUp = false
        this.newUser.email = ''
        this.newUser.first_name = ''
        this.newUser.last_name = ''
        this.newUser.password = ''
        this.newUser.password2 = ''
        this.newUser.agree = false
        this.newUser.newsletter = true
      }, error => {
        this.loading = false
        let message = error.response.data

        if (message.name === 'email_already_exists') {
          this.$notify({ message: this.$t('email_registered') }, 'warning', 'fa-exclamation')
        }
      })
    },
    getCaptcha: function () {
      Auth.getCaptcha().then(response => {
        this.captcha = response.data
      })
    },
    login: function () {
      let lang = ''
      this.loading = true
      this.errorCode = ''

      if (this.$i18n && this.$i18n.locale) {
        lang = this.$i18n.locale
      }

      Auth.login(this.email.trim(), this.password, this.captchaText, lang).then(response => {
        this.loading = false

        if (response.data && response.data.twofactor) {
          this.userData = response.data
          return window.$(this.$refs.modalTwoFactor).modal('show')
        }

        this.loginSuccess(response.data)
      }, error => {
        this.getCaptcha()
        this.loading = false
        this.errorCode = error.response.data.name

        if (this.errorCode === 'invalid_username') {
          this.$notify({ message: this.$t('invalid_username') }, 'warning', 'fa-exclamation')
        }

        if (this.errorCode === 'invalid_password') {
          this.$notify({ message: this.$t('invalid_password') }, 'warning', 'fa-exclamation')
        }

        if (this.errorCode === 'invalid_captcha') {
          this.$notify({ message: this.$t('invalid_captcha') }, 'warning', 'fa-exclamation')
        }

        if (this.errorCode === 'unconfirmed') {
          this.$notify({ message: this.$t('unconfirmed_email') }, 'warning', 'fa-exclamation')
        }

        if (this.errorCode === 'deactivated_account') {
          this.$notify({ message: this.$t('deactivated_account') }, 'warning', 'fa-exclamation')
        }

        if (this.errorCode === 'banned_account') {
          this.$notify({ message: this.$t('banned_account') }, 'danger', 'fa-exclamation')
        }

        console.log('Error when trying to login', error.response.data, this.captchaText)
        this.captchaText = ''
      })
    },
    validateEmail: function (email) {
      email = email || this.newUser.email

      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      return re.test(String(email).toLowerCase())
    },
    onChangeEmail: function () {
      if (this.newUser.email && !this.validateEmail()) {
        this.$notify({ message: this.$t('email_is_not_valid') }, 'warning', 'fa-exclamation')
      }
    },
    resendConfirmEmail: function () {
      Auth.resendConfirmEmail(this.newUser.email).then(response => {
        this.$notify({ message: this.$t('confirmation_success') }, 'success', 'fa-check')
      }, error => {
        console.log(error)
        this.$notify({ message: this.$t('confirmation_error') }, 'danger', 'fa-exclamation')
      })
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.path.match(/signup/)) {
        this.showSignUp = true
      } else {
        this.showSignUp = false
      }
    }
  },
  created: function () {
    this.desktop = !navigator.userAgent.match(
      /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
    )

    if (this.$route.path.match(/signup/)) {
      this.showSignUp = true
    }

    if (this.$route.query.email) {
      this.newUser.email = this.$route.query.email
      this.readOnlyEmail = true
    }

    if (this.$route.query.upgraded) {
      this.newUser.upgraded = 1
    }

    Public.getLocationSettings().then(response => {
      if (response.data.code) {
        this.defaultCountry = response.data.code
      }
    })

    if (window.gapi) {
      window.gapi.load('client:auth2', () => {
        window.gapi.client
          .init({
            discoveryDocs: [
              'https://people.googleapis.com/$discovery/rest?version=v1'
            ],
            clientId: '551586398920-cpk7un4cut3kgvo4ocusoqfjcpf8oeif.apps.googleusercontent.com',
            scope: 'profile'
          })
          .then(
            () => {
              const GoogleAuth = window.gapi.auth2.getAuthInstance()
              Vue.prototype.GoogleAuth = GoogleAuth
            },
            () => {
              if (window.gapi.auth2.getAuthInstance()) {
                Vue.prototype.GoogleAuth = window.gapi.auth2.getAuthInstance()
              }
            }
          )
      })
    }

    let title = 'Indiefy | Login / Sign In'

    if (this.$route.query.next) {
      title += ' - Next: ' + this.$route.query.next
    }

    if (this.$route.query.plan) {
      title += this.$route.query.next
    }

    window.document.title = title

    this.getCaptcha()

    this.newUser.newsletter = true
  },
  mounted: function () {
    if (this.$route.query.confirmed) {
      setTimeout(() => {
        this.$notify({ message: this.$t('confirmation_sucess') }, 'success', 'fa-check')
      }, 500)
    }
    if (this.$route.query.create_account) {
      this.showSignUp = true
    }
  },
  components: {
    VuePhoneNumberInput
  }
}
</script>

<style lang="scss" scoped>
.login {
  background: #fff;
}

.btn-social {
  background-color: white;
  border: 1px solid #eee;
}
.login .wrapper.wrapper-login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: unset;
  padding: 15px;
}

.login .wrapper.wrapper-login .container-login {
  max-width: 540px;
  padding: 70px;
  border-radius: 5px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 18px -2px rgba(0,0,0,0.35);
  background: #fff;
}

.login .wrapper.wrapper-login .container-signup {
  .container-size {
    padding: 70px;
    max-width: 540px;
    margin: 0 auto;
    box-shadow: 0px 0px 18px -2px rgba(0,0,0,0.35);
    background: #fff;
    color: #495057;
    border-radius: 5px;
  }
  padding: 0px;
  width: 50%;
  margin: auto;
}

.login .wrapper.wrapper-login .container-signup-text {
  .container-size-text {
    max-width: 540px;
    margin: 0 auto;
    margin-right: 30px;
    ul li {
      b {
        font-weight: 600;
      }
      p:nth-child(2) {
        font-weight: 300;
      }
      list-style: none;
      color: #495057;
    }
  }
  padding: 0px;
  width: 50%;
  margin: auto;
}

.login .wrapper.wrapper-login .container-login:not(.container-transparent),
.login .wrapper.wrapper-login .container-signup:not(.container-transparent) {
  background: #fff;
  -webkit-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  -moz-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  border: 1px solid #ebecec;
}

.login .wrapper.wrapper-login .container-login h3,
.login .wrapper.wrapper-login .container-signup h3 {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 25px;
}

.login .wrapper.wrapper-login .container-login .form-sub,
.login .wrapper.wrapper-login .container-signup .form-sub {
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
}

.login .wrapper.wrapper-login .container-login .btn-login,
.login .wrapper.wrapper-login .container-signup .btn-login {
  padding: 15px 0;
  width: 135px;
}

.login .wrapper.wrapper-login .container-login .form-action,
.login .wrapper.wrapper-login .container-signup .form-action {
  text-align: center;
  padding: 25px 10px 0;
}

.login .wrapper.wrapper-login .container-login,
.login .wrapper.wrapper-login .container-signup {
  align-items: center;
  justify-content: space-between;
}

.login .wrapper.wrapper-login .container-signup .form-action {
  display: flex;
  justify-content: center;
}

.login .wrapper.wrapper-login-full {
  justify-content: unset;
  align-items: unset;
  padding: 0 !important;
  max-width: 1680px;
  margin: auto;
}

.login .login-aside {
  padding: 25px;
}

.login .login-aside .title {
  font-size: 36px;
}

.login .login-aside .subtitle {
  font-size: 22px;
}

.background-figures {
  position: absolute;
  top:0;
  width: 100%;
}

.login .show-password {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  cursor: pointer;
}

.login .custom-control-label {
  white-space: nowrap;
}

.login .label-break-spaces{
  white-space: break-spaces;
}

.bg-video {
  height: 100%;
  position: absolute;
  opacity: 0.4;
}

.login-aside {
  p {
    text-shadow: 1px 1px 2px #333232;
    z-index: 10;
  }
}

.animated-word {
  color: #f22e75;
  font-weight: bold;
}

body .login .login-aside .title {
  font-size: 3em;
}

.login-left {
  background: #F5F2F7;
  clip-path: polygon(0 0, 100% 0, 100% 40%, 0 70%);
  width: 100%;
  height: 100vh;
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: #d4c2e2;
  animation: animate 25s linear infinite;
  bottom: -150px;
  border-radius: 10px;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(-45vh) rotate(0deg);
    opacity: 1;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}

.container-social {
  .btn-block {
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    text-align: center;
    margin-bottom: 20px;
    min-height: 50px;
    position: relative;
  }
  // .bg-facebook {
  //   background-color: #1877f2;
  //   border-color: #1877f2;
  // }

  .bg-google {
    background-color: #ffffff;
    border-color: #ffffff;
    color: #495057;
  }

  .fa-twitter {
    color: #1DA1F2;
  }

  // .bg-twitter {
  //   background-color: #1DA1F2;
  //   border-color: #1DA1F2;
  //   line-height: 2em;
  // }

  img, i {
    position: absolute;
    left: 20px;
  }
  i {
    top: 18px;
  }
}

.btn-back, .login-form .h3, .btn-privacy, .confirm-title, .confirm-description {
  color: #495057;
}
.container-signup-text .fas.fa-check-circle{
  color: #5714ff;
}

.container-terms {
  label {
    font-size: 11px !important;
    font-weight: 300;
    line-height: 1.3em;
  }
}

.logo-mobil {
  display: none;
}

.confirm-img {
  max-width: 120px;
}

.confirm-description a {
  text-decoration: underline;
}

.link-to-confirm {
  color: #5714ff;
  text-decoration: underline;
  cursor: pointer;
}

.yes-account {
  margin-top: 1.8rem !important;
}

.copyright {
  position: absolute;
  bottom: -20vh;
}

@media only screen and (max-width: 1440px)  {
  body {
    font-size: 12.5px;
  }
  label {
    font-size: 13px !important;
  }
  .form-group, .form-check {
      margin-bottom: 0;
      padding: 8px;
  }
  .mt-3, .my-3 {
    margin-top: 0.8rem!important;
  }
  .pb-3, .py-3 {
    padding-bottom: 0.8rem!important;
  }
  .form-control {
    font-size: 13px;
    padding: .5rem 0.8rem;
  }
  .form-group label, .form-check label {
    margin-bottom: .3rem;
  }
  .login .wrapper.wrapper-login .container-signup {
    .container-size {
      max-width: 540px;
      padding: 62px;
      margin-left: 30px;
      button[type='submit'] {
        font-size: 12.5px;
        padding: .6rem 1.2rem;
        min-height: 40px;
        margin-top: 0 !important;
      }
      .msg, .btn-link {
        font-size: 12.5px;
      }
    }
  }
  .login .wrapper.wrapper-login .container-login h3,
  .login .wrapper.wrapper-login .container-signup h3 {
    margin-bottom: 20px;
  }
  .container-terms {
    label {
      font-size: 10px !important;
      line-height: 1.2em;
    }
  }
  .login .wrapper.wrapper-login .container-login .form-action,
  .login .wrapper.wrapper-login .container-signup .form-action {
    text-align: center;
    padding: 22px 10px 0;
  }
  .login .wrapper.wrapper-login .container-login {
    max-width: 540px;
    padding: 64px;
  }
  .container-social .btn-block {
    font-size: 12.5px;
    margin-bottom: 15px;
    padding: .6rem 1.2rem;
    min-height: 45px;
  }
  .login-account.mt-5.text-right {
    font-size: 12.5px;
    margin-top: 2rem !important;
    button {
      font-size: 12.5px;
    }
  }

  .container-social {
    h3 {
      margin-bottom: 0.8rem!important;
    }
  }
  .login-account {
    font-size: 12.5px;
    margin-top: 2rem !important;
    bottom: -44px !important;
    button {
      font-size: 12.5px;
    }
  }
  .container-login .login-form {
    .form-group.mb-3 {
      margin-bottom: 0 !important;
    }
    button[type='submit'] {
      font-size: 12.5px;
      padding: .6rem 1.2rem;
      min-height: 40px;
      margin-top: 0 !important;
    }
    .btn-link {
      font-size: 12.5px;
      margin-top: 0 !important;
    }
    .link.float-right {
      font-size: 13px !important;
    }
  }
}

@media screen and (max-width: 1366px) {
  .login .wrapper.wrapper-login .container-signup .container-size{
    padding: 30px 62px;
  }
  .login .wrapper.wrapper-login .container-signup h3 {
    margin-bottom: 10px;
  }
  .login-form .form-group.pb-3 {
    padding-bottom: 0.2rem !important;
  }
  .wrapper.wrapper-login .container-signup .form-action {
    padding-top: 15px !important;
  }
  .login .container-terms {
    margin-top: 0.4rem !important;
  }
  .login .wrapper.wrapper-login .container-login {
    padding: 32px 62px;
  }
  .login .wrapper.wrapper-login .container-login h3 {
    margin-bottom: 0px !important;
  }
  .login-form .form-group {
    padding: 4px 8px;
  }
  .login-account.mt-5.text-right{
    margin-top: 1.5rem !important;
  }
}

@media screen and (max-width: 1024px) {
  .container-signup-text {
    display: none;
  }
  .login .wrapper.wrapper-login .container-signup{
    width: 90%;
    .container-size {
      padding: 20px !important;
      margin: 0 auto !important;
    }
  }
  .logo-mobil {
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
    margin-top: 20px;
  }
}

@media only screen and (max-width: 768px)  {
  .login .wrapper.wrapper-login .container-login {
    width: 95% !important;
    margin-top: 8px;
    padding-top: 40px !important;
    .container-social h3{
      text-align: center;
      margin-top: 30px;
    }
  }
  .login .wrapper.wrapper-login .container-signup {
    width: 95%;
    .container-size {
      margin-top: 8px !important;
      margin-bottom: 60px !important;
    }
    h3 {
      text-align: center !important;
    }
    .form-group {
      padding: 10px !important;
    }
  }
  .login .login-form .login-account {
    text-align: center;
    position: initial;
    right: initial;
    bottom: initial;
  }
  .login-account{
    text-align: center !important;
  }
  .login .wrapper.wrapper-login .container-login h3,
  .login .wrapper.wrapper-login .container-signup h3 {
    text-align: center;
    margin-top:20px;
  }
}

@media screen and (max-width: 578px) {
  .login-header-mobile {
    display: none !important;
  }

  .main-logins {
    margin-top: -150px;
  }

  .form-action-d-flex {
    flex-direction: column;
    align-items: start !important;
  }

  .login .wrapper-login-full {
    flex-direction: column;
  }

  .login .login-aside {
    width: 100% !important;
    height: 100vh;
  }

  .login .login-aside .title {
    font-size: 24px;
  }

  .login .login-aside .subtitle {
    font-size: 16px;
  }

  .bg-video {
    width: 100% !important;
    height: inherit !important;
  }

  .login-left {
    height: auto !important;
  }

  .container-social {
    .btn-block {
      padding: .65rem 1.4rem !important;
      text-align: center;
    }
  }
}

@media screen and (max-width: 400px) {
  .wrapper-login {
    padding: 15px !important;
  }

  .container-login {
    width: 100% !important;
    padding: 60px 15px !important;
  }
}

@media screen and (max-width: 320px) {
  .login .wrapper.wrapper-login .container-signup{
    margin-top: 8px;
    width: 95%;
  }
  .login .wrapper.wrapper-login .container-signup .container-size{
    padding: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue